import { Table} from 'react-bootstrap';
import { Loader } from '../../../../utils/tools';
import Button from '@mui/material/Button';


const ImageStatusChange = ({
    articles,
    type,
    goToNewsAproval,
    goToNewsPublish,
    goToNewsBlock,
    status
   
}) => {

   

    return(
        <>
            { articles?
                <>
                    <Table striped bordered hover>
                    <thead>
                            <tr>
                               <th>{type}  Aproval </th>
                               <th>{type}  Publish</th>
                               <th>{type} Block</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {status}
                        {(status!=='BLK') ?
       
   
                       <> 
                       <tr key={articles.newsID}>



                       {(status!=='PSD' ) ?
       
   
                  <> 

                                        {(status!=='FAD' ) ?
       
   
                  <>   
                       <td className='action_btn status_btn'>
                                <Button
                                 className='mt-3'
                                variant='contained'
                                color='primary'
                                onClick={()=>goToNewsAproval(articles.newsID)}
                                >
                                    Aproval
                                    
                                    </Button>
                        </td>
                        </>  :null}
                        <td className='action_btn edit_btn'
                        color='primary'
                          
                        >
                              <Button
                                 className='mt-3'
                                variant='contained'
                                color='warning'
                                onClick={()=> goToNewsPublish(articles.newsID)}
                                >
                                   Publish
                                    
                                    </Button>
                           
                        </td>
                        </>  :null}

                        <td className='action_btn remove_btn'
                      
                           
                        >
                             <Button
                                 className='mt-3'
                                variant='contained'
                                color='error'
                                onClick={()=>goToNewsBlock(articles.newsID)}
                                >
                                   Block
                                    
                                    </Button>
                            
                        </td>
                    </tr>
                    </>
                                 :null}
                        </tbody>
                    </Table>
                    
                </>
            :
                <Loader/>
            }


        </>
    )

}
export default ImageStatusChange;